export const PERMS = [
  ["approve_requests", "Gestire ferie e permessi"],
  ["view_sick", "Vedere le malattie"],
  ["publish_announcements", "Pubblicare comunicazioni"],
  ["view_calendar", "Vedere il calendario assenze"],
];

export const can = (user, perm) => user?.role === "admin" || (user?.role === "manager" && (user.permissions || []).includes(perm));

export const ROLE_LABEL = { admin: "Amministratore", manager: "Responsabile", employee: "Dipendente" };
